import { html } from "../lib/bind";
import { logo } from "../lib/logo";

export function notFoundView(): Node {
  const fragment = html`<div class="view">
    <div class="card not-found">
      <p class="not-found-title">This page doesn't exist</p>
      <p class="not-found-body">The link may be out of date, or the record may have been deleted.</p>
      <a class="btn btn-primary" href="/" data-link>Back to dashboard</a>
    </div>
  </div>`;
  const card = fragment.querySelector(".not-found");
  if (!card) throw new Error("not-found markup missing expected elements");
  card.prepend(logo("mark", { className: "not-found-mark", decorative: true }));
  return fragment;
}
